// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"368":"ac6afa2b","453":"8ab44547","834":"c49ff157"}[chunkId] + ".chunk.js";
};